// src/components/LocalizedNavLink.jsx
import { NavLink, useParams } from "react-router-dom";

export default function LocalizedNavLink({ to = "", ...props }) {
  const { lng } = useParams();
  const normalized = to.startsWith("/") ? to : `/${to}`;
  const href = `/${lng}${normalized}`;
  return <NavLink to={href} {...props} />;
}
